import * as React from 'react';
import { LocationPickerGroup } from '../LocationPickerGroup';
import { ILocationsColumn } from '../../types';
import * as styles from './LocationPickerColumns.css';

interface ILocationPickerColumnsProps {
  columns: ILocationsColumn[];
  onLinkClick(locationId: number): void;
}

export const LocationPickerColumns: React.FC<ILocationPickerColumnsProps> = ({ columns, onLinkClick }) => {
  return (
    <div className={styles['container']}>
      {columns.map((column, index) => (
        <div key={index}>
          {column.map(({ title, locations }) => (
            <LocationPickerGroup key={title} title={title} locations={locations} onLinkClick={onLinkClick} />
          ))}
        </div>
      ))}
    </div>
  );
};
